<div class="container" *ngIf="this.currentInvoice">
  <div class="left"><app-pdf-viewer [fileUrl]="this.currentInvoice.downloadUrl"></app-pdf-viewer></div>
  <div class="right" [ngStyle]="{ 'margin-top': formMarginTop }">
    <app-invoice-controls [currentIndex]="this.currentIndex" [maxIndex]="this.maxIndex" (numberChange)="onIndexChange($event)"> </app-invoice-controls>
    <app-invalid-form [currentInvoice]="this.currentInvoice" [currentIndex]="this.currentIndex" [clientId]="this.clientId"></app-invalid-form>
  </div>
</div>
